import React from "react";
import BlocTamplete from "../../componentes/templates/Bloc";

export default function Bloc() {
  return (
    <BlocTamplete />
  );
}
